<template>
  <div v-if="renderData && renderData.length && renderData.length > 1 && !isDesktop" class="categoriesCard minHeightMweb" >
    <div class="categoriesCard__title-cont">
      <h3 v-if="renderName" class="title text-left pl-4">{{renderName}}</h3>
      <p v-if="getDescription" class="descrition">{{getDescription}}</p>
    </div>
    <div class="headtop prelative top-banner p-2">
      <carousel ref="my-carousel" :navigationEnabled="isDesktop"
        :paginationEnabled="!isDesktop" navigationNextLabel=" " navigationPrevLabel=" "
        :autoplay="false" :speed="500" :class="isDesktop ? 'bannerview' : 'mobileBannerView'" :perPage="1"
        :paginationPadding="1" :paginationSize="6" :paginationPosition="'bottom'"
        :paginationColor="'#979a9f'"
      >
        <slide v-for="(renderArr, index) in getMobileRenderedData" :key="index">
          <div v-for="(item, index) in renderArr" :key="index" class="col-6 p-1 ">
            <router-link :to=item.url>
            <div class="homeCatTile pointer shimmerBg" v-bannerImageLoad="getBannerImpressionData(item, index)" @click="homeTileRedirection(item, index)">
              <img
                class="customFade shimmerBg"
                :class="isDesktop ? null : 'img-card'"
                :data-url="getBannerImage(item.image)"
                :alt="item.url"
                style="aspect-ratio: auto 16 / 9;"
              />
            </div>
          </router-link>
          </div>
        </slide>
      </carousel>
    </div>
  </div>
  <div class="container homeboxes w-100 home-tiles minHeightWeb" v-else-if="isDesktop && renderData && renderData.length && renderData.length > 1">
    <div v-if="isDesktop && renderData && renderData.length && renderData.length > 1" class="row">
      <div class="category-heading col-md-12"><div class=""><span>{{renderName}}</span></div></div>
      <div :class="'col-sm-' + item.col_width" class='bx col-12' v-for="(item, index) in renderData.slice(0,renderData.length - 1)" :key="item.index">
        <div v-if="item.childs" class="row">
          <div v-for="(ch, chIndex) in item.childs" :key="chIndex + Math.random().toString()" class='bx col-12' :class="'col-sm-' + ch.col_width">
            <div class="tilethumb">
              <div class="homeCatTile pointer zoom scaleImg shimmerBg" v-bannerImageLoad="getBannerImpressionData(ch, `${index + 1} - ${chIndex + 1}`)" @click="homeTileRedirection(ch, chIndex)">
                <div class="htilebtn txt-upper fbold">{{ch.product_type}}</div>
                <img id="vests" class="gtmTileClick customFade shimmerBg" :data-url="getBannerImage(ch.image_web)" :alt="ch.product_type" style="aspect-ratio: auto 16 / 9;">
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="tilethumb">
            <router-link :to="item.url">
            <div class="homeCatTile pointer scaleImg zoom shimmerBg" v-bannerImageLoad="getBannerImpressionData(item, index)" @click="homeTileRedirection(item, index)">
                <!-- <div class="htilebtn txt-upper fbold">{{item.product_type}}</div> -->
                <img id="vests" class="gtmTileClick customFade img-auto shimmerBg" :data-url="getBannerImage(item.image_web)" :alt="item.product_type" width="480" height="480" style="aspect-ratio: auto 16 / 9;">
            </div>
          </router-link>
          </div>
        </div>
      </div>
  </div>
</div>
</template>

<script>
var $ = require('jquery')
window.jQuery = $
import Vue from 'vue'
import {Carousel, Slide} from 'vue-carousel'
import {mapGetters} from 'vuex'
import {getProductUrl} from '../../assets/js/common'
export default {
  data () {
    return {
      isDesktop: this.$parent.$parent.isDesktop
    }
  },
  props: ['renderName', 'renderData', 'homepath', 'widgetType'],
  components: {
    Carousel,
    Slide
  },
  computed: {
    ...mapGetters(['isExclusive', 'authStatus', 'webcategory']),
    getMobileRenderedData: function () {
      const mobileData = this.renderData.slice(0, this.renderData.length - 1).map(data => {
        if (data.childs) {
          return data.childs
        } else {
          return data
        }
      })
      const mobileRenderedData = mobileData.flat()
      if (mobileRenderedData && mobileRenderedData.length) {
        let orgArr = [...mobileRenderedData]
        let orgArrLen = orgArr.length
        let splitLen = orgArrLen > 4 ? 4 : orgArrLen
        let newArr = []
        for (let i = 0; i < orgArrLen;) {
          newArr.push(orgArr.slice(i, i + splitLen))
          i += splitLen
        }
        return newArr
      }
    },
    getDescription: function () {
      if (this.renderData && this.renderData.length > 1) {
        return this.renderData[this.renderData.length - 1][3]
      }
    }
  },
  methods: {
    homeTileRedirection: function (item, index) {
      let payload = {
        payload: item,
        index: index
      }
      const gender = Vue.ls.get('tss_landingCategory')
      const bannerImpressionData = this.getBannerImpressionData(item, index)
      this.$store.commit('GTAG_EVENT', {eventName: 'home_category_tile',
        payload: {
          index: payload.index,
          category: item.product_type,
          imageURL: payload.payload.image,
          productType: payload.payload.product_type,
          productURL: payload.payload.url
        }}
      )
      this.$store.commit('SET_NAVIGATION_WIDGET', this.renderName || this.widgetType)
      let eventPaylod = {
        creative_name: bannerImpressionData.creative_name ? bannerImpressionData.creative_name : 'NA',
        creative_slot: bannerImpressionData.creative_slot || bannerImpressionData.creative_slot === 0 ? bannerImpressionData.creative_slot : 'NA',
        promotion_id: bannerImpressionData.promotion_id ? bannerImpressionData.promotion_id : 'NA',
        promotion_name: bannerImpressionData.promotion_name ? bannerImpressionData.promotion_name : 'NA',
        creative_image: bannerImpressionData && bannerImpressionData.creative_img ? bannerImpressionData.creative_img : 'NA',
        promotion_tab: this.webcategory || 'NA'
      }
      this.$store.dispatch('ECOMMERCE_EVENT', { eventName: 'select_promotion', payload: eventPaylod })
      this.$store.commit('GTM_EVENT', { eventName: 'select_promotion', payload: eventPaylod })
      this.$store.commit('MOENGAGE_EVENT', {eventName: 'HOMEPAGE-SECTION',
        payload: {
          Section_Name: this.renderName || '',
          Section_Index: index + 1,
          Product_Category: item.product_type || '',
          Product_Name: '',
          Product_ID: item.id || '',
          Product_Price: '',
          Product_Artist: '',
          ProductImage_URL: this.isDesktop ? item.image_web : item.image,
          Product_URL: this.getProductUrl(false, item.url, ''),
          GENDER: gender
        }}
      )
      if (item.url) {
        this.$router.push(item.url)
      }
    },
    getBannerImpressionData (obj, index) {
      return {
        promotion_id: obj.id || '',
        promotion_name: obj.promotion_name || this.renderName || '',
        creative_name: obj.product_type || obj.title || this.renderName || '',
        creative_slot: index,
        creative_img: this.isDesktop ? obj.image_web : obj.image || 'NA',
        currency: 'INR'
      }
    },
    getProductUrl,
    getBannerImage (img) {
      return img && img.length && img.includes('https://img.thesouledstore.com') ? img.replace('https://img.thesouledstore.com', 'https://prod-img.thesouledstore.com') : img
    }
  }
}
</script>

<style scoped>
.minHeightMweb {
  /* min-height: 452px; */
  min-height: auto;
}
.minHeightWeb{
  /* min-height: 550px; */
  min-height: auto;
}
 [v-cloak] {
    background: #ed2d2f;
  }
  .shimmerBg {
    background-color: #FCEAE7;
  }
  .zoom {
    transition: transform .2s;
    width: 100%;
    height: 100%;
    margin: 0px auto;
  }
  .zoom:hover {
    -ms-transform: scale(1.1); /* IE 9 */
    -webkit-transform: scale(1.1); /* Safari 3-8 */
    transform: scale(1.1);
    -webkit-transition: all 0.3s ease-in;
  }
  .exclusive-bar {
    background-color: #3498db;
    color: #fff;
    padding: 10px;
  }
  .glow {
    transition: opacity .15s ease-in;
  }
  .glow:hover,
  .glow:focus {
    opacity: 1;
    transition: opacity .15s ease-in;
  }
  .tilethumb {
    margin-bottom: 7px;
    position: relative;
    height: 100%;
  }
  .htilebtn {
    color: #fff;
    font-size: 1.6em;
    z-index: 9;
    padding-left: 8px;
    padding-bottom: 7px;
    line-height: 1em;
    bottom: 0px;
    top: unset;
  }

  .category-heading {
    margin: 1.5rem 0;
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 1.24;
    letter-spacing: normal;
    text-align: center;
    color: #282c3f;
    text-transform: uppercase;
  }

  .countdown-text {
    font-size: 40px;
  }

  .headtop {
    background-color: #ffffff;
  }
  .lined-heading {
    margin-top: 20px;
  }

  .discount-container {
    margin-top: 30px;
  }

  .discount-info {
    box-shadow: 0px -2px 3px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    position: absolute;
    background: white;
    color:#353535;
    padding: 14px 0 20px 0;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    z-index: 10;
    text-align: center;

  }

  .discount-info--1 {
    font-size: 20px;
    font-family: 'source_sans_prosemibold';
    margin: 0 0 5px 0;
    text-transform: uppercase;
  }

  .discount-info--2 {
    font-size: 18px;
    font-family: 'source_sans_prosemibold';
    margin: 0;
  }

  @media screen and (max-width: 768px) {
    .home-background {
      background-color: #eeeeee;
    }
    .home-tiles {
      background-color: #ffffff;
    }
    .headtop {
      padding-bottom: 1rem;
    }
    .category-heading {
      margin: 1rem 0;
    }
  }

  @media screen and (max-width: 991px) {
    .htilebtn {
      font-size: 1.3em;
    }

    .lined-heading {
      margin-top: 10px;
    }

    .mob_mb7 {
      margin-bottom: 7px;
    }

    .homeboxes .bx {
      padding-right: 3.5px !important;
      padding-left: 3.5px !important;
      float: left;
    }

    .homeboxes .row {
      margin-left: -3.5px;
      margin-right: -3.5px;
    }

    .container {
      padding-right: 7px;
      padding-left: 7px;
    }

    .tileHead {
      margin-bottom: 5px;
    }
    .countdown-text {
      font-size: 18px;
      margin-bottom: 10px;
    }
  }

  @media screen and (min-width: 992px) {
    .homeboxes .bx {
      padding-right: 5px;
      padding-left: 5px;
      float: left;
    }

    .homeboxes .row {
      margin-left: -5px;
      margin-right: -5px;
    }
    .exclusive-tile {
      margin-bottom: 14px;
    }
  }

  @media (min-width: 1200px) {
    .tilethumb {
      margin-bottom: 19px;
    }

    .homeboxes .bx {
      padding-right: 7px;
      padding-left: 7px;
      float: left;
    }
  }

  .categoriesCard {
    margin: 2rem 0;
  }
  .categoriesCard .title {
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.24;
    letter-spacing: normal;
    text-align: center;
    color: #282c3f;
    text-transform: uppercase;
    margin: 0;
  }
  .categoriesCard__title-cont {
    margin-bottom: 2rem;
  }
  .categoriesCard__title-cont .descrition {
    font-size: 1.6rem;
    line-height: 1.26;
    letter-spacing: normal;
    text-align: center;
    color: #525964;
    margin: 0;
  }
  @media screen and (max-width: 768px) {
    .categoriesCard .title {
      font-size: 1.13rem;
    }
    .categoriesCard {
      margin: 0;
      padding: 1rem 0rem 0rem 0rem;
      background-color: #ffffff;
    }
    .categoriesCard__title-cont {
      margin-bottom: .6rem;
    }
    .img-card {
      border-radius: 4px;
    }
    .categoriesCard__title-cont .descrition {
      font-size: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// CarouselGrid2By2.vue?69c7d3bb